'use client';

import { usePathname } from 'next/navigation';

import { useListingParams } from '../../issues/listing-params-context/listing-params-context';
import {
  selectDraftIssueWithStore,
  useStore,
} from '../../state/store-provider';

const staticBackRoutes: Record<string, string> = {
  '/issue/create/area': '/',
  '/issue/create/department': '/issue/create/area',
  '/issue/create/category': '/issue/create/department',
  '/issue/create/escalation': '/issue/create/immediate-action',
  '/issue': '/',
};

const DEFAULT_BACK_ROUTE = '/';

const dynamicCreateIssueRoutes = new Set([
  '/issue/create/summary',
  '/issue/create/immediate-action',
  '/issue/create/feedback-summary',
]);

export const useBackRoute = (): string => {
  const pathname = usePathname();
  const { listingUrl } = useListingParams();
  const { category, department } = useStore(selectDraftIssueWithStore);

  if (pathname && staticBackRoutes[pathname]) {
    return staticBackRoutes[pathname];
  }

  if (pathname && dynamicCreateIssueRoutes.has(pathname)) {
    if (category) {
      return '/issue/create/category';
    }
    if (department) {
      return '/issue/create/department';
    }
    return '/issue/create/area';
  }

  // /issue/[issueid] → /issue (with preserved listing params if available)
  if (
    pathname?.startsWith('/issue/') &&
    !pathname.startsWith('/issue/create/')
  ) {
    return listingUrl ?? '/issue';
  }

  return DEFAULT_BACK_ROUTE;
};
